import { Navigate, useLocation } from "react-router-dom"

export const PrivateRoute = ({ children }: { children: JSX.Element }) => {
  const token = localStorage.getItem("token")
  const refreshToken = localStorage.getItem("refreshToken")
  const user = localStorage.getItem("user")
  const location = useLocation()

  if (!token || !refreshToken || !user) {
    const returnTo = encodeURIComponent(location.pathname + location.search)
    return (
      <Navigate
        to={`/login?returnTo=${returnTo}`}
        replace
      />
    )
  }

  return children
}
